import * as React from "react";
import { AnchorHTMLAttributes } from "react";
import classNames from "classnames";
import "./styles.scss";

interface AnchorButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string;
    color?: "primary" | "secondary";
}
const AnchorButton = ({
    children,
    href,
    color = "primary",
    ...restOfProps
}: AnchorButtonProps): JSX.Element => {
    return (
        <a
            className={classNames({
                "anchor-button": true,
                secondary: color === "secondary"
            })}
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            {...restOfProps}
        >
            {children}
        </a>
    );
};

export default AnchorButton;
